import { blue, grey } from '@ant-design/colors'
import { Card, Col, Divider, Row, Typography } from 'antd'
import { useContext } from 'react'
import { WorkareaGroupWithWorkareas } from '../../../../../domain/workareas/group'
import VSpace from '../../../../common/VSpace'
import { centsToDollarsDisplay } from '../../../../displayFormatters'
import { ItemsContext } from '../../../../Items/ItemsRoot'
import ApprovedOrOnHoldDisplay from '../../List/ApprovedOrOnHoldDisplay'
import PricingTypeDisplay from '../../../PricingTypeDisplay'
import TruncatedName from '../../../../common/TruncatedName'

const { Text } = Typography

type Props = {
  group: WorkareaGroupWithWorkareas
  selectedWorkareaId: number | undefined
  onSelectWorkarea: (workareaId: number) => void
  cardOptions: React.ReactNode
}

const HiddenWorkareaCard = ({ group, onSelectWorkarea, selectedWorkareaId, cardOptions }: Props) => {
  const { workareaSummaries } = useContext(ItemsContext)
  const workareaSummary = workareaSummaries.find(s => s.workareaId === group.workareas[0].id)

  return <Card
    style={{
      borderRadius: 8,
      cursor: 'pointer',
      border: selectedWorkareaId === group.workareas[0].id ? `1px solid ${blue.primary}` : '1px solid #f0f0f0',
      backgroundColor: selectedWorkareaId === group.workareas[0].id ? blue[0] : '#fff',
    }}
    onClick={() => onSelectWorkarea(group.workareas[0].id)}
  >
    <Row gutter={20}>
      <Col span={20}>
        <VSpace style={{ width: '100%' }}>
          <Text strong>
            <TruncatedName name={group.name} />
          </Text>
          <div>
            <Text strong>{centsToDollarsDisplay(workareaSummary?.finalPrice)}</Text>
            <Divider type='vertical' style={{ borderColor: grey.primary }} />
            <Text type='secondary'>{workareaSummary?.estimatedHours} Hours</Text>
          </div>
          <PricingTypeDisplay pricingType={group.pricingType} />
          <ApprovedOrOnHoldDisplay workareaGroup={group} />
        </VSpace>
      </Col>
      <Col span={4} style={{ alignContent: 'center' }}>
        {cardOptions}
      </Col>
    </Row>
  </Card>
}

export default HiddenWorkareaCard
